import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../common/Header";
import $ from "jquery";
import useAuth from "../../../hooks/useAuth";
import Toastify from "../../common/Toastify";
import { GETREQUEST, POSTREQUEST } from "../../helpers/ServiceRequest";

function EditCustomer() {
  const [StandardRebate, setStandardRebate] = useState('');
  const [standardRebateErr, setStandardRebateErr] = useState(false);
  const [rebateCrates, setRebateCrates] = useState('');
  const [priceListReqd, setPriceListReqd] = useState('');
  const [invoiceSignatureReqd, setInvoiceSignatureReqd] = useState('');
  const [showProductCode, setShowProductCode] = useState('');
  const [RRP, setRRP] = useState(0);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [errors, setErrors] = useState({});
  const [customerData, setCustomerData] = useState({});
  const { user } = useAuth();
  const formValuesObj = {
    'CustomerN': 'CustomerName',
    'CustomerC': 'CustomerContact',
    'FaxN': 'FaxNumber',
    'InvoiceA1': 'InvoiceAddress1',
    'InvoiceA2': 'InvoiceAddress2',
    'InvoiceA3': 'InvoiceAddress3',
    'InvoiceS': 'InvoiceSuburb',
    'InvoiceSt': 'InvoiceState',
    'InvoicePC': 'InvoicePostCode',
    'TruckA': 'TruckAddress',
  }

  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight + "px");
  });

  const handleChange = (e) => {
    let name = e.target.name
    name = formValuesObj[name] || name;
    setCustomerData((prevData) => ({
      ...prevData,
      [name]: e.target.value
    }));

    if (Object.keys(errors).length > 0 && errors[name]) {
      setErrors((prevData) => {
        const updatedError = { ...prevData };
        delete updatedError[name];
        return updatedError;
      });
    }
  }

  const checkErrors = async () => {
    let isError = false;
    const fields = ['CustomerName',
      "CustomerContact",
      "EmailAddresses",
      "CustomerCode",
      "InvoiceAddress1",
      "InvoiceSuburb",
      "InvoiceState",
      "InvoicePostCode",
      "PrintOrder"
    ]

    fields.map((field) => {
      let value = customerData[field];
      if (!value) {
        setErrors((prevData) => ({
          ...prevData,
          [field]: true
        }));
        isError = true;
      } else {
        setErrors((prevData) => {
          const updatedError = { ...prevData };
          delete updatedError[field];
          return updatedError;
        });
      }
    });

    return isError;
  }

  let navigate = useNavigate();
  const { id } = useParams();
  useEffect(() => {
    const fetchData = async () => {
      let URL = process.env.REACT_APP_API_URL + "/get-customer/" + id;
      let response = await GETREQUEST(URL, user.jwtToken);
      if (response?.data) {
        let data = response?.data;
        data['InvoiceAddress2'] = data['InvoiceAddress2'] ?? "";
        data['InvoiceAddress3'] = data['InvoiceAddress3'] ?? "";
        data['BuyerCode'] = data['BuyerCode'] ?? "";
        data['Category'] = data['Category'] ?? "";
        data['DeliveryInstructions'] = data['DeliveryInstructions'] ?? "";
        data['OrderNotes'] = data['OrderNotes'] ?? "";
        data['PurchaseOrder'] = data['PurchaseOrder'] ?? "";
        data['PrintOrder'] = data['PrintOrder'] ?? "";

        setCustomerData(data);
        const {
          RebateCrates,
          PriceListReqd,
          InvoiceSignatureReqd,
          ShowProductCode,
          StandardRebate,
          RRP
        } = response.data;

        setRebateCrates(RebateCrates);
        setStandardRebate(StandardRebate)
        setPriceListReqd(PriceListReqd);
        setInvoiceSignatureReqd(InvoiceSignatureReqd);
        setShowProductCode(ShowProductCode);
        setRRP(RRP);
      }
    }
    fetchData();
  }, []);

  const editCustomer = async (e) => {
    e.preventDefault();
    const isError = await checkErrors();
    let URL = process.env.REACT_APP_API_URL + "/update-customer";

    if (Object.keys(errors).length > 0 || isError) {
      return false;
    }

    if (StandardRebate === "" || StandardRebate < 0) {
      setStandardRebateErr(true);
      return false;
    }

    let payload = {
      ...customerData,
      StandardRebate: StandardRebate,
      RebateCrates: rebateCrates,
      PriceListReqd: priceListReqd,
      InvoiceSignatureReqd: invoiceSignatureReqd,
      ShowProductCode: showProductCode,
      RRP: RRP,
      Current: parseInt(customerData?.Current),
      Category: customerData?.Category || ''
    };

    setMessage('');
    setMessageType('');
    let response = await POSTREQUEST(URL, payload, user.jwtToken);
    if (response?.data) {
      if (response.data.success) {
        setMessage(response.data.message);
        setMessageType('success');
        setTimeout(() => {
          navigate("/customers");
        }, 2000);
      } else {
        setMessage(response.data.message);
        setMessageType('error');
      }
    } else {
      setMessage(response?.error?.message || 'Failed to update Customer !!');
      setMessageType('error');
    }
  };
  return (
    <React.Fragment>
      <Header />
      {message && <Toastify message={message} type={messageType} />}
      <main className="bg-lite-grey overflow-auto">
        <section className="px-4 pt-3 pb-4">
          <div className="table-elements">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item fs-15">
                  <Link
                    to="/customers"
                    className="text-decoration-none text-primary"
                  >
                    Customers
                  </Link>
                </li>
                <li
                  className="breadcrumb-item fs-15 active"
                  aria-current="page"
                >
                  Edit Customer
                </li>
              </ol>
            </nav>
          </div>
          <div className="card border-bottom-0">
            <div className="card-header bg-white d-flex align-items-center justify-content-between border-bottom-0 p-4">
              <h1 className="title-semibold fs-24 mb-0">Edit Customer</h1>
            </div>
            <div className="card-body p-4 pt-3 border-bottom">
              <h2 className="title-medium title-semibold fs-16 mb-3">
                Customer Contact Information
              </h2>
              {Object.keys(customerData).length > 0 && <form onSubmit={editCustomer}>
                <div className="row border-bottom pb-4">
                  <div className="width-xxl-34 width-xl-50 width-lg-80">
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Customer Name
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md" +
                            (errors['CustomerName'] ? " is-invalid" : "")
                          }
                          placeholder="Enter customer name"
                          name="CustomerN"
                          value={customerData?.CustomerName}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Customer Contact
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md" +
                            (errors['CustomerContact'] ? " is-invalid" : "")
                          }
                          name="CustomerC"
                          placeholder="Enter customer contact"
                          value={customerData?.CustomerContact}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Fax Number
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className="form-control input-md"
                          name="FaxN"
                          placeholder="Enter fax number"
                          value={customerData?.FaxNumber}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3 align-items-start">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Invoice Address
                      </label>
                      <div className="col">
                        <textarea
                          type="text"
                          className={
                            "form-control" +
                            (errors['InvoiceAddress1'] ? " is-invalid" : "")
                          }
                          name="InvoiceA1"
                          placeholder="Enter invoice address"
                          rows="3"
                          value={customerData?.InvoiceAddress1}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        ></textarea>
                      </div>
                    </div>

                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Suburb - State - PC
                      </label>
                      <div className="col">
                        <div className="row gx-2">
                          <div className="col-sm-6">
                            <input
                              type="text"
                              className={
                                "form-control input-md" +
                                (errors['InvoiceSuburb'] ? " is-invalid" : "")
                              }
                              name="InvoiceS"
                              placeholder="Enter suburb"
                              value={customerData?.InvoiceSuburb}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            />
                          </div>
                          <div className="col-sm-3">
                            <input
                              type="text"
                              className={
                                "form-control input-md" +
                                (errors['InvoiceState'] ? " is-invalid" : "")
                              }
                              name="InvoiceSt"
                              placeholder="State"
                              value={customerData?.InvoiceState}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            />
                          </div>
                          <div className="col-sm-3">
                            <input
                              type="text"
                              placeholder="PC"
                              className={
                                "form-control input-md" +
                                (errors['InvoicePostCode'] ? " is-invalid" : "")
                              }
                              name="InvoicePC"
                              value={customerData?.InvoicePostCode}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="width-xxl-34 width-xl-50 width-lg-80 ps-xl-5">
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Customer Code
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          placeholder="Enter customer code"
                          className={
                            "form-control input-md" +
                            (errors['CustomerCode'] ? " is-invalid" : "")
                          }
                          name="CustomerCode"
                          value={customerData?.CustomerCode}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Truck Address
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          placeholder="Enter truck address"
                          className="form-control input-md"
                          value={customerData?.TruckAddress}
                          name="TruckA"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>

                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Email Address
                      </label>
                      <div className="col">
                        <textarea
                          type="text"
                          placeholder="Enter email address"
                          rows="3"
                          value={customerData?.EmailAddresses}
                          className={
                            "form-control" +
                            (errors['EmailAddresses'] ? " is-invalid" : "")
                          }
                          name="EmailAddresses"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        ></textarea>
                      </div>
                    </div>
                    <div className="cmb-15 row g-3 align-items-start">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Invoice Address2
                      </label>
                      <div className="col">
                        <textarea
                          type="text"
                          className="form-control"
                          placeholder="Enter invoice address2"
                          rows="3"
                          name="InvoiceA2"
                          value={customerData?.InvoiceAddress2}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        ></textarea>
                      </div>
                    </div>
                    <div className="cmb-15 row g-3 align-items-start">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Invoice Address3
                      </label>
                      <div className="col">
                        <textarea
                          type="text"
                          className="form-control"
                          placeholder="Enter invoice address3"
                          rows="3"
                          name="InvoiceA3"
                          value={customerData?.InvoiceAddress3}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="spacer-4"></div>
                <h2 className="title-medium title-semibold fs-16 mb-3">
                  Other Information
                </h2>
                <div className="row">
                  <div className="width-xxl-34 width-xl-50 width-lg-80">
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Buyer Code
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className="form-control input-md"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          value={customerData?.BuyerCode}
                          name="BuyerCode"
                          placeholder="Enter buyer code "
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Standard Rebate
                      </label>
                      <div className="col">
                        <input
                          type="number"
                          className={
                            "form-control input-md" +
                            (standardRebateErr ? " is-invalid" : "")
                          }
                          value={StandardRebate}
                          onChange={(e) => {
                            setStandardRebateErr(false);
                            setStandardRebate(e.target.value);
                          }}
                          placeholder="Enter standard rebate"
                        />
                      </div>
                    </div>

                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Delivery <br /> Instructions
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className="form-control input-md"
                          name="DeliveryInstructions"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          value={customerData?.DeliveryInstructions}
                          placeholder="Enter delivery instructions"
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3 align-items-start">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Order Notes
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          placeholder="Enter order notes"
                          className="form-control input-md"
                          name="OrderNotes"
                          value={customerData?.OrderNotes}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-xl-28 width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Rebate Crates
                      </label>
                      <div className="col">
                        <input
                          type="checkbox"
                          className="form-check-input pe-0"
                          id="remember"
                          checked={rebateCrates}
                          onChange={(e) => {
                            if (e.target.checked === true) {
                              setRebateCrates(1);
                            } else {
                              setRebateCrates(0);
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-xl-28 width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Price List Reqd?
                      </label>
                      <div className="col">
                        <input
                          type="checkbox"
                          className="form-check-input pe-0"
                          id="remember"
                          checked={priceListReqd}
                          onChange={(e) => {
                            if (e.target.checked === true) {
                              setPriceListReqd(1);
                            } else {
                              setPriceListReqd(0);
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-xl-28 width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        RRP
                      </label>
                      <div className="col">
                        <input
                          type="checkbox"
                          className="form-check-input pe-0"
                          id="remember"
                          checked={RRP}
                          onChange={(e) => {
                            if (e.target.checked === true) {
                              setRRP(1);
                            } else {
                              setRRP(0);
                            }
                          }}
                        />
                      </div>
                    </div>
                  
                  </div>
                  <div className="width-xxl-34 width-xl-50 width-lg-80 ps-xl-5">
                    <div className="cmb-15 row g-3">
                      <label className="width-xl-28 width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Purchase Order
                      </label>
                      <div className="col-sm-6">
                        <input
                          type="text"
                          placeholder="Enter purchase order"
                          className="form-control input-md"
                          name="PurchaseOrder"
                          value={customerData?.PurchaseOrder}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-xl-28 width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Print Order
                      </label>
                      <div className="col-sm-4">
                        <input
                          type="number"
                          className={
                            "form-control input-md" +
                            (errors['PrintOrder'] ? " is-invalid" : "")
                          }
                          name="PrintOrder"
                          value={customerData?.PrintOrder}
                          placeholder="Enter print order"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>

                    <div className="cmb-15 row g-3">
                      <label className="width-xl-28 width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Inv Signature Reqd?
                      </label>
                      <div className="col">
                        <input
                          type="checkbox"
                          className="form-check-input pe-0"
                          id="remember"
                          checked={invoiceSignatureReqd}
                          onChange={(e) => {
                            if (e.target.checked === true) {
                              setInvoiceSignatureReqd(1);
                            } else {
                              setInvoiceSignatureReqd(0);
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-xl-28 width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Show Product Code?
                      </label>
                      <div className="col">
                        <input
                          type="checkbox"
                          className="form-check-input pe-0"
                          id="remember"
                          checked={showProductCode}
                          onChange={(e) => {
                            if (e.target.checked === true) {
                              setShowProductCode(1);
                            } else {
                              setShowProductCode(0);
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-xl-28 width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Category
                      </label>
                      <div className="col-sm-4">
                        <select
                          className="form-select input-md"
                          aria-label="Default select example"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          name="Category"
                          value={customerData['Category']}
                        >
                          {!customerData['Category'] && <option disabled value={''}></option>}
                          <option value={'A'}>A</option>
                          <option value={'B'}>B</option>
                          <option value={'C'}>C</option>
                          <option value={'D'}>D</option>
                          <option value={'E'}>E</option>
                          <option value={'F'}>F</option>
                        </select>
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-xl-28 width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Status
                      </label>
                      <div className="col-sm-4">
                        <select
                          className="form-select input-md"
                          aria-label="Default select example"
                          name="Current"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          value={customerData?.Current}
                        >
                          <option value={1}>Active</option>
                          <option value={0}>Inactive</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-5">
                  <div className="col d-flex justify-content-end align-items-end">
                    <button
                      type="submit"
                      className="btn btn-md btn-secondary text-white d-flex align-items-center px-4 fw-medium rounded-3"
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </form>}
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}
export default EditCustomer;
